import React from "react";
import { Stack, Box, Typography, hslToRgb } from "@mui/material";

import { stringToAlphabetSum } from "../../../helpers/userImageColor";
import { HubChartTitle } from "../HubChartTitle";

import { StyledStack, StyledTextList } from "./styles";

export const HubTextChart = ({ field, limit = 10 }) => {
  const counts = field?.series?.map((s) => s?.count);
  const high = Math.max(...counts);
  const hueShift = stringToAlphabetSum(field?.name);

  const data = field?.series?.map((s, i) => {
    const value = s?.value;
    const label = value?.length > 30 ? `${value.substring(0, 30)}...` : value;
    const shift = ((high - s?.count) / high) * 45;
    const color = hslToRgb(`hsl(${209 + hueShift}, 100%, ${50 + shift}%)`);

    return { color, label, count: s?.count };
  });

  const sorted = data?.sort((a, b) => b?.count - a?.count);
  const otheredArray =
    sorted?.length > limit
      ? [
          ...sorted?.slice(0, limit),
          {
            color: sorted[0]?.color,
            label: "Other",
            count: sorted
              ?.slice(limit, sorted.length)
              ?.reduce((a, b) => a + (isNaN(b?.value) ? 0 : b?.count), 0),
          },
        ]
      : sorted;

  return (
    <StyledStack key={field.name}>
      <HubChartTitle type={field?.type} name={field?.name} />
      <Stack gap="5px" width="100%">
        {otheredArray?.map(({ color, label, count }) => (
          <StyledTextList>
            <Box
              width="10px"
              height="10px"
              borderRadius="3px"
              backgroundColor={color}
            />
            <Typography>{label}</Typography>
            <Typography variant="caption" sx={{ marginLeft: "auto" }}>
              {count}
            </Typography>
          </StyledTextList>
        ))}
      </Stack>
    </StyledStack>
  );
};

export default HubTextChart;
